const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: () => ''
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js